/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetCaseListFilters
 */
export interface WidgetCaseListFilters {
    /**
     * 
     * @type {string}
     * @memberof WidgetCaseListFilters
     */
    escalation?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetCaseListFilters
     */
    statuses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WidgetCaseListFilters
     */
    titleContains?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCaseListFilters
     */
    classification?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCaseListFilters
     */
    classificationSubCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetCaseListFilters
     */
    resolutionReasonValues?: Array<string>;
}

/**
 * Check if a given object implements the WidgetCaseListFilters interface.
 */
export function instanceOfWidgetCaseListFilters(value: object): value is WidgetCaseListFilters {
    return true;
}

export function WidgetCaseListFiltersFromJSON(json: any): WidgetCaseListFilters {
    return WidgetCaseListFiltersFromJSONTyped(json, false);
}

export function WidgetCaseListFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetCaseListFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'escalation': json['escalation'] == null ? undefined : json['escalation'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'titleContains': json['titleContains'] == null ? undefined : json['titleContains'],
        'classification': json['classification'] == null ? undefined : json['classification'],
        'classificationSubCategory': json['classificationSubCategory'] == null ? undefined : json['classificationSubCategory'],
        'resolutionReasonValues': json['resolutionReasonValues'] == null ? undefined : json['resolutionReasonValues'],
    };
}

export function WidgetCaseListFiltersToJSON(json: any): WidgetCaseListFilters {
    return WidgetCaseListFiltersToJSONTyped(json, false);
}

export function WidgetCaseListFiltersToJSONTyped(value?: WidgetCaseListFilters | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'escalation': value['escalation'],
        'statuses': value['statuses'],
        'titleContains': value['titleContains'],
        'classification': value['classification'],
        'classificationSubCategory': value['classificationSubCategory'],
        'resolutionReasonValues': value['resolutionReasonValues'],
    };
}

